<template>
  <div class="car-datepicker__container">
    <datepicker inline
                :value="selectedDate"
                :disabled-dates="disabledDates"
                :day-cell-content="dayCellContent"
                @selected="selectDate"
                :monday-first="true"
                :highlighted="highlightedDates"
                :language="datePickerLanguage"/>
  </div>
</template>

<script>
import * as datepickerTranslations from 'vuejs-datepicker/dist/locale';
import language from '@/util/language';
import helpers from '@/util/helpers';
import Datepicker from 'vuejs-datepicker';
import { sortBy } from 'lodash';

export default {
  name: 'DatepickerContainer',
  props: {
    dayCellContent: {
      type: Function,
      default: function(day) {
        return day.date;
      }
    },
    availableDates: {
      type: Array,
      default: function() {
        return [];
      }
    },
    disabledDates: {
      type: Object,
      default: function() {
        let disabledDates = {};
        if (this.availableDates.length) {
          let mainAvailableDates = sortBy(this.availableDates, [(timeslot) => {
            if (timeslot.dateFrom) {
              return timeslot.dateFrom.time;
            }
            return timeslot.start;
          }]);
          disabledDates.to = mainAvailableDates[0].start;
          disabledDates.from = mainAvailableDates[mainAvailableDates.length - 1].start;
          let availableDates = mainAvailableDates.map(slot => new Date(slot.start));
          let possibleAvailableDates = helpers.getDatesArray(disabledDates.to, disabledDates.from);
          disabledDates.dates = possibleAvailableDates.filter(date => !helpers.isInArray(availableDates, date));
          return disabledDates;
        }
        return disabledDates;
      }
    },
    selectedDate: {
      type: Date,
      default: function() {
        return null;
      }
    }
  },
  methods: {
    selectDate(date) {
      this.$emit('selectDate', date)
    }
  },
  computed: {
    datePickerLanguage() {
      if (datepickerTranslations[language.getApplicationLanguageCode()]) {
        return datepickerTranslations[language.getApplicationLanguageCode()];
      } else {
        // Fallback to English
        return datepickerTranslations['en'];
      }
    },
    highlightedDates() {
      if (this.availableDates.length) {
        return {
          dates: this.availableDates.map(date => date.start)
        }
      }
      return {};
    }
  },
  components: {
    Datepicker
  }
}
</script>
